import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import './index.scss';
import Photo from './components/photo/Photo';
import Title from './components/title/Title';
import Remark from './components/remark/Remark';
import Text from '@hfe/max-text';
import Privilege from './components/privilege/Privilege';
import Button from './components/button/Button';
import { useMonitorJumper } from '@nibfe/mcp-monitor-sdk';
function ComprehensiveCard(props) {
    var _a, _b, _c, _d;
    const { vo, index, onCardClick, onCardShow } = props;
    const { monitorNavigateToSmart } = useMonitorJumper();
    const handleCardClick = () => {
        if (onCardClick) {
            onCardClick(vo, index);
            monitorNavigateToSmart(vo === null || vo === void 0 ? void 0 : vo.goodsDetailUrl);
        }
    };
    const handleCardShow = () => {
        if (onCardShow) {
            onCardShow(vo, index);
        }
    };
    // 将 IFeSuperGroupGoodsVo 的属性映射到原有的组件属性
    const privilegeList = ((_a = vo.goodsGiftList) === null || _a === void 0 ? void 0 : _a.map(gift => ({
        label: gift.giftIcon,
        desc: gift.giftText
    }))) || [];
    return <View className="comprehensive-card-container" onAppear={handleCardShow} onClick={handleCardClick}>
      <Photo showTag={!!vo.productTypeName} productTypeName={vo.productTypeName} bottomTag={((_b = vo.bottomTagImgSource) === null || _b === void 0 ? void 0 : _b.uri) || ''} img={vo.goodsImage}/>
      <View className="comprehensive-card-right-container">
        <Title title={vo.goodsName}/>
        <Remark displayScore={((_c = props.vo) === null || _c === void 0 ? void 0 : _c.displayScore) || 'auto'} score={vo.goodsScore} soldInfo={((_d = vo.goodsSales) === null || _d === void 0 ? void 0 : _d.toString()) || ''} recommendReason={vo.goodsRecommendReason}/>
        <Text x-if={vo.goodsReview} numberOfLines={1} className="comprehensive-card-location">
          {vo.goodsReview}
        </Text>
        {privilegeList.map((item, index) => {
        return <Privilege key={index} label={item.label} desc={item.desc}/>;
    })}
        <Button actualPrice={vo.goodsSellPrice} originalPrice={vo.goodsOriginalPrice} reducedPrice={vo.discountInfo || ''} buyText={vo.comprehensiveButtonText || '抢购'} averagePrice={vo.promotionText}/>
      </View>
    </View>;
}
export default memo(ComprehensiveCard);
